import {
    RECEIPT_ENTRY_ACTION_TYPE, RECEIPT_LIST_ACTION_TYPE, PERFORMA_INVOICE_ACTION_TYPE,
    RECEIPT_DETAILS_ACTION_TYPE, proformaInvoiceUrl, receiptDetailsUrl,
    receiptUpdateUrl, receiptListUrl, headers, receiptNoUrl, RECEIPT_NUMBER_ACTION_TYPE,
    receiptShareUrl, RECEIPT_SHARE_ACTION_TYPE, receiptSaveUrl, receiptDelUrl,
    generateVoucherUrl, RECEIPT_GENERATE_VOUCHER_ACTION_TYPE, RECEIPT_DEL_ACTION_TYPE,
    RECEIPT_UPDATE_ACTION_TYPE, getPendingReceiptDetailsUrl, PENDING_RECEIPT_DETAILS_ACTION_TYPE,
    fetchAuthReport, GET_RECEIPT_PDF_ACTION_TYPE, DOWNLOAD_RECEIPT, shareOutstandingEmailUrl,
    SHARE_OUTSTANDING_EMAIL_ACTION_TYPE
} from "../../../utils/constants"
import { axiosPost, axiosGet } from "../../../react_axios/Axios"

export const receipt_entry_save_action = (voucher_type_id, applicant_id, con_rate, bank_amount, tds_amount, exch_diff, on_acc_amt, cr_amount, total_amount, receipt_no, receipt_date, payment_mode_id, instrument_no, instrument_date, bank_name, branch_name, narration, payment_received_date, bank_account_id, currency_id, proformaList, otherChargesList) => async (dispatch) => {
    try {
        const mapdata = {
            user_id: sessionStorage.getItem("user_id"),
            award_event_id: sessionStorage.getItem("award_event_id"),
            voucher_type_id: voucher_type_id,
            applicant_id: applicant_id,
            con_rate: con_rate,
            bank_amount: bank_amount,
            tds_amount: tds_amount,
            exch_diff: exch_diff,
            on_acc_amt: on_acc_amt,
            cr_amount: cr_amount,
            total_amount: total_amount,
            receipt_no: receipt_no,
            receipt_date: receipt_date,
            payment_mode_id: payment_mode_id,
            instrument_no: instrument_no,
            instrument_date: instrument_date != '' ? instrument_date : null,
            bank_name: bank_name,
            branch_name: branch_name,
            narration: narration,
            payment_received_date: payment_received_date,
            bank_detail_id: bank_account_id,
            currency_id: currency_id,
            proformaList: proformaList,
            otherChargesList: otherChargesList,
        }
        const res = await axiosPost(receiptSaveUrl, mapdata, headers);

        dispatch({
            type: RECEIPT_ENTRY_ACTION_TYPE,
            payload: res,
        })
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
}

export const receiptUpdate_action = (receipt_id, voucher_type_id, applicant_id, con_rate, bank_amount, tds_amount, exch_diff, on_acc_amt, cr_amount, total_amount, receipt_no, receipt_date, payment_mode_id, instrument_no, instrument_date, bank_name, branch_name, narration, payment_received_date, bank_account_id, currency_id, proformaList, otherChargesList) => async (dispatch) => {
    try {
        const mapdata = {
            user_id: sessionStorage.getItem("user_id"),
            award_event_id: sessionStorage.getItem("award_event_id"),
            receipt_id: receipt_id,
            voucher_type_id: voucher_type_id,
            applicant_id: applicant_id,
            con_rate: con_rate,
            bank_amount: bank_amount,
            tds_amount: tds_amount,
            exch_diff: exch_diff,
            on_acc_amt: on_acc_amt,
            cr_amount: cr_amount,
            total_amount: total_amount,
            receipt_no: receipt_no,
            receipt_date: receipt_date,
            payment_mode_id: payment_mode_id,
            instrument_no: instrument_no,
            instrument_date: instrument_date != '' ? instrument_date : null,
            bank_name: bank_name,
            branch_name: branch_name,
            narration: narration,
            payment_received_date: payment_received_date,
            bank_detail_id: bank_account_id,
            currency_id: currency_id,
            proformaList: proformaList,
            otherChargesList: otherChargesList,
        }
        const res = await axiosPost(receiptUpdateUrl, mapdata, headers);

        dispatch({
            type: RECEIPT_UPDATE_ACTION_TYPE,
            payload: res,
        })
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
}

export const receipt_outstanding_mail_action = (receipt_id) => async (dispatch) => {
    try {
        const params = {
            award_event_id: sessionStorage.getItem("award_event_id"),
            receipt_id: receipt_id
        }
        const res = await axiosGet(shareOutstandingEmailUrl, params, headers);
        dispatch({
            type: SHARE_OUTSTANDING_EMAIL_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }

}

export const receipt_list_search_action = (recptNo, applicant_name, receiptFromDate, receiptToDate) => async (dispatch) => {

    try {
        const params = {
            user_id: sessionStorage.getItem("user_id"),
            award_event_id: sessionStorage.getItem("award_event_id"),
            receipt_no: recptNo,
            applicant_name: applicant_name,
            receiptFromDate: receiptFromDate,
            receiptToDate: receiptToDate,
        }
        const res = await axiosGet(receiptListUrl, params, headers);
        dispatch({
            type: RECEIPT_LIST_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }

}

export const receiptDetails_action = (receiptID) => async (dispatch) => {

    try {
        const params = {
            award_event_id: sessionStorage.getItem("award_event_id"),
            receipt_id: receiptID,
        }
        const res = await axiosGet(receiptDetailsUrl, params, headers);
        dispatch({
            type: RECEIPT_DETAILS_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }

}

export const proformaInvoice_action = (applicant_id) => async (dispatch) => {

    try {
        const params = {
            award_event_id: sessionStorage.getItem("award_event_id"),
            application_form_id: applicant_id,
        }
        const res = await axiosGet(proformaInvoiceUrl, params, headers);
        dispatch({
            type: PERFORMA_INVOICE_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }

}


export const receiptNo_action = (award_event_id) => async (dispatch) => {

    try {
        const params = {
            award_event_id: sessionStorage.getItem("award_event_id"),
        }

        const res = await axiosGet(receiptNoUrl, params, headers);
        dispatch({
            type: RECEIPT_NUMBER_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }

}

export const generateVoucher_action = (applicant_id, voucher_type_id, bank_account_id, currency_id,
    con_rate, bank_amount, tds_amount, exch_diff, on_acc_amt, cr_amount, total_amount, award_event_id, award_event_profile_id, proformaList, otherChargesList) => async (dispatch) => {
        try {
            const mapData = {
                user_id: sessionStorage.getItem("user_id"),
                applicant_id: applicant_id,
                voucher_type_id: voucher_type_id,
                bank_account_id: bank_account_id,
                currency_id: currency_id,
                con_rate: con_rate,
                bank_amount: bank_amount,
                tds_amount: tds_amount,
                exch_diff: exch_diff,
                on_acc_amt: on_acc_amt,
                cr_amount: cr_amount,
                total_amount: total_amount,
                award_event_id: award_event_id,
                award_event_profile_id: award_event_profile_id,
                proformaList: proformaList,
                otherChargesList: otherChargesList,
            }
            const res = await axiosPost(generateVoucherUrl, mapData, headers);
            dispatch({
                type: RECEIPT_GENERATE_VOUCHER_ACTION_TYPE,
                payload: res,
            })
            return Promise.resolve(res)
        } catch (error) {
            return Promise.reject(error)
        }
    }

export const deleteReceipt_action = (receiptId) => async (dispatch) => {
    try {
        const params = {
            user_id: sessionStorage.getItem("user_id"),
            receipt_id: receiptId,
        }
        const res = await axiosGet(receiptDelUrl, params, headers);
        dispatch({
            type: RECEIPT_DEL_ACTION_TYPE,
            payload: res
        })
        return Promise.resolve(res)

    } catch (error) {
        return Promise.reject(error)
    }
}

export const pendingReceiptDetails_action = (ID) => async (dispatch) => {

    try {
        const params = {
            Userid: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            AccountID: JSON.parse(sessionStorage.getItem('loginDataSS')).AccountID,
            AccountPaymentID: ID,
        }
        const res = await axiosGet(getPendingReceiptDetailsUrl, params, headers);
        dispatch({
            type: PENDING_RECEIPT_DETAILS_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }

}


export const getReceiptPdf_action = (receptId) => async (dispatch) => {
    try {
        var list = [];
        const mapdata1 = {
            "ParameterName": "@ReceiptID",
            "ParameterValue": receptId,
            "ParameterDataType": "int"
        }
        list.push(mapdata1);
        const mapData = {
            "report_name": 'ReceiptVoucher.rpt',
            "parameter_details": list
        }
        const res = await axiosPost(fetchAuthReport, mapData);
        dispatch({
            type: GET_RECEIPT_PDF_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const receiptShare_action = (receiptIdArray) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ReceiptShareID: receiptIdArray,
        }
        const res = await axiosPost(receiptShareUrl, params, headers);
        dispatch({
            type: RECEIPT_SHARE_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const download_receipt_action =
    (application_form_id, receipt_id) => async (dispatch) => {
        try {
            var list = [];
            const mapdata = {
                "ParameterName": "@application_form_id",
                "ParameterValue": application_form_id,
                "ParameterDataType": "int"
            }
            const mapdata2 = {
                "ParameterName": "@receipt_id",
                "ParameterValue": receipt_id,
                "ParameterDataType": "int"
            }
            list.push(mapdata);
            list.push(mapdata2);
            const mapData = {
                "user_id": sessionStorage.getItem("user_id"),
                "report_name": "ReceiptVoucher.rpt",
                "report_file_name": `ReceiptVoucher${receipt_id}`,
                "config_id": 0,
                "parameter_details": list,

            }
            const res = await axiosPost(fetchAuthReport, mapData, headers);
            dispatch({
                type: DOWNLOAD_RECEIPT,
                payload: res,
            });

            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    };
